import { useState } from 'react';
import { fileService } from '../services/api';

export const useFileUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);

  const uploadFile = async (file) => {
    try {
      setIsUploading(true);
      setError(null);
      const result = await fileService.uploadFile(file);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    isUploading,
    error,
    uploadFile
  };
};

export default useFileUpload;
